import { Injectable } from '@angular/core';
import { WritableSignal, signal } from '@angular/core';
import {TableRow, TableColumn} from '../../../shared/models/components/tables/table.models';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {   ProjectData } from '../../models/serviceModels/request/modelDefinitionsReq.model';
import {   modelDefinitionsResponse } from '../../models/serviceModels/response/model-definitions-response.models';


@Injectable({
    providedIn: 'root'
  })
  export class ModelDefinitionsService {

    constructor(private apiService: ApiService) { }

    getProjectInputsByModel(projectData: ProjectData): Observable<modelDefinitionsResponse>{
        return this.apiService.post('api/Data/GetInputsModelsByProjectId', projectData );
        // return this.apiService.post('api/Data/GetProyectInputsByModel', projectData );
    }
  }